/**
 * OMI Wheels nav fix — capture phase
 * Fires before ALL bubble-phase handlers — cannot be stopped by theme JS
 */
document.addEventListener('click', function (e) {
  var a = e.target;
  while (a && a.tagName !== 'A') { a = a.parentElement; }
  if (!a) return;
  if (a.closest && a.closest('.nav-dropdown') && !a.hasAttribute('aria-haspopup')) {
    var href = a.getAttribute('href');
    if (href && href.charAt(0) !== '#' && href !== '') {
      e.stopImmediatePropagation();
      e.stopPropagation();
      window.location.href = href;
    }
  }
}, true);
